import { Icon } from 'ui';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import './teacher-tool-card.scss';

const TeacherToolCard = ({ tool, onClick }) => {
  const [isPressed, setIsPressed] = useState(false);

  const handleClick = () => {
    if (tool.available && onClick) {
      onClick(tool);
    }
  };

  const handleMouseDown = () => {
    if (tool.available) {
      setIsPressed(true);
    }
  };

  const handleMouseUp = () => {
    setIsPressed(false);
  };

  const handleMouseLeave = () => {
    setIsPressed(false);
  };

  const getCardClass = () => {
    let className = 'teacher-tool-card';
    if (!tool.available) {
      className += ' teacher-tool-card--disabled';
    } else if (isPressed) {
      className += ' teacher-tool-card--pressed';
    }
    return className;
  };

  const descriptionId = `teacher-tool-card-${tool.id}-description`;

  // The button goes inside the heading, not around the card, so the heading stays one. aria-disabled and
  // not `disabled`, so keyboard users still reach the card and hear it is unavailable.
  return (
    <div className={getCardClass()}>
      <div className="teacher-tool-card__icon">
        <Icon name={tool.icon || 'magic'} color={tool.iconColor || '#FFBC34'} size="md" />
      </div>
      <div className="teacher-tool-card__content">
        <h3 className="teacher-tool-card__title">
          <button
            aria-describedby={descriptionId}
            aria-disabled={!tool.available || undefined}
            className="teacher-tool-card__button"
            onClick={handleClick}
            onMouseDown={handleMouseDown}
            onMouseLeave={handleMouseLeave}
            onMouseUp={handleMouseUp}
            type="button"
          >
            {tool.title}
          </button>
        </h3>
        <p className="teacher-tool-card__description" id={descriptionId}>
          {tool.description}
        </p>
      </div>
    </div>
  );
};

TeacherToolCard.propTypes = {
  tool: PropTypes.shape({
    id: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    icon: PropTypes.string,
    iconColor: PropTypes.string,
    category: PropTypes.string,
    available: PropTypes.bool,
  }).isRequired,
  onClick: PropTypes.func,
};

export default TeacherToolCard;
